export const PAGE_LOADING = "@page.loading";
